import React from 'react';

function WhiteHoverButton({ children, onClick = () => {} }) {
  return (
    <button type="button" className="flex items-center border-0 bg-transparent h-[60px] px-5 duration-300 ease-out hover:bg-white rounded-lg cursor-pointer" onClick={onClick}>
      {children}
    </button>
  );
}

export default WhiteHoverButton;
